import { NetworkStatus, useQuery } from "@apollo/client";
import { useEffect } from "react";

import { Flag } from "@medbillai/utils/flag";

import { useAuth } from "../../../lib/auth";
import { useBoolVariation } from "../../../lib/flag";
import { useAppState } from "../../../lib/useAppState";
import { showWelcomeScreenQuery } from "./queries";

export const useWelcome = () => {
  const forceShowWelcomeScreen = useBoolVariation(
    Flag.FORCE_SHOW_WELCOME_SCREEN,
    false,
  );
  const { isActive } = useAppState();
  const { isAuthenticated, isReady } = useAuth();

  const { data, loading, refetch, networkStatus } = useQuery(
    showWelcomeScreenQuery,
    {
      skip: !isAuthenticated || !isReady,
    },
  );

  // Refetch when app becomes active after being backgrounded
  // biome-ignore lint/correctness/useExhaustiveDependencies: networkStatus intentionally excluded to prevent infinite loop
  useEffect(() => {
    if (
      isActive &&
      networkStatus !== NetworkStatus.refetch &&
      networkStatus !== NetworkStatus.loading
    ) {
      void refetch();
    }
  }, [isActive, refetch]);

  const shouldShow = forceShowWelcomeScreen || data?.showWelcomeScreen;

  return { shouldShow, loading, refetch };
};
